import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { emptyArray } from 'ui-components/default-props/empty';
import style from './ship-together-destination-modal.module.less';

export const ShipTogetherNotes = ({ notes = emptyArray }) => {
  const typeToLabelMap = {
    NotesFromBuyer: (
      <FormattedMessage defaultMessage='Note from Buyer' description='shipTogetherDestinationModal.noteFromBuyer' id='Z1The+' />
    ),
    NotesToBuyer: <FormattedMessage defaultMessage='Note to Buyer' description='shipTogetherDestinationModal.noteToBuyer' id='5ccZT1' />,
    Internal: <FormattedMessage defaultMessage='Internal Note' description='shipTogetherDestinationModal.internal' id='fnp/wx' />,
  };

  return (
    <div>
      {notes.map((note, index) => {
        return (
          <div key={index} className={style['shipment-sections']}>
            <div className={style['shipment-labels']}>{typeToLabelMap[note.type]}</div>
            <div className={style['shipment-info']}>{note.body}</div>
          </div>
        );
      })}
    </div>
  );
};

ShipTogetherNotes.propTypes = {
  notes: PropTypes.array,
};
